import script from "./OptionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=4358a642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4358a642"]])

export default __exports__